import { createRouter, createWebHistory } from 'vue-router';
import spiderman from '@/spiderman';

const { clinic } = spiderman;
const routes = [
  {
    path: '/membership/:clinic',
    component: () => import('../views/Membership/Index.vue'),
    meta: { title: `${clinic.金安心.fullname}-會員綁定` },
  },
  {
    path: '/appointment/making/:clinic',
    component: () => import('../views/Appointment/Making/Index.vue'),
    meta: { title: `${clinic.金安心.fullname}-線上預約` },
  },
  {
    path: '/appointment/query/:clinic',
    component: () => import('../views/Appointment/Query.vue'),
    meta: { title: `${clinic.金安心.fullname}-預約查詢` },
  },
  // {
  //   path: '/feedback/:clinic',
  //   component: () => import('../views/FeedBack.vue'),
  //   meta: { title: `${clinic.金安心.fullname}-意見回饋` },
  // },
  {
    path: '/visitor-registration/:clinic',
    component: () => import('../views/VisitorRegistration/Index.vue'),
    meta: { title: `${clinic.金安心.fullname}-訪客登記` },
  },
  {
    path: '/chat/:clinic',
    component: () => import('../views/Chat/Index.vue'),
    meta: { title: `${clinic.金安心.fullname}-線上客服` },
  },
  {
    path: '/devx',
    component: () => import('../views/Devx.vue'),
    meta: { title: 'Devx' },
  },
  // 任何其他網址轉址到 Home 頁面
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/Home.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || clinic.金安心.fullname;
  next();
});

export default router;
